export const webEndPoint = "https://senthanamuthankidswear.shop/dev_api/api/";
// export const imageEndPoint = "https://kongumangai.com/kongu/";